/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useCancellationQuote } from '../../CancellationQuoteProvider';
import { useHistory } from 'react-router';
import getPathNameForStage from '../../utils/getPathNameForStage';
import { useDetailsBooking } from 'lib/hooks';

const useSyncUrlWithStage = () => {
  const { booking } = useDetailsBooking();
  const { error, cancellationState } = useCancellationQuote();
  const { replace, location } = useHistory();

  const pathname = getPathNameForStage(booking.id, cancellationState, error);

  useEffect(() => {
    if (pathname === location.pathname) {
      return;
    }

    replace(pathname);
  }, [replace, pathname]);
};

export default useSyncUrlWithStage;
